import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {PreparationResourceTypeSearchModel} from "../preparation-resource-type-search.model";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-preparation-resource-type-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(PreparationResourceTypeSingleSelectEditControlComponent),
        provideSearchModel(PreparationResourceTypeSearchModel)
    ]
})
export class PreparationResourceTypeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<PreparationResourceTypeSearchModel> {
    constructor(model: PreparationResourceTypeSearchModel, injector: Injector) {
        super(model, injector, "id", "name");
    }
}
